module.exports = __webpack_public_path__ + "img/Color Mismatch.1596a23e.png";